module.exports = __webpack_public_path__ + "static/antonomy-5f0fcbf1a6e6026884fc8aff64bbb79a.png";